import { fetchAuthSession } from "aws-amplify/auth";
import { useEffect } from "react";

const BfCacheClearfix: React.FC = () => {
  useEffect(() => {
    const onPageShow = async ({ persisted }: PageTransitionEvent) => {
      // Only back/forward-cache restores need handling; a normal load re-runs
      // the auth guards on its own.
      if (!persisted) {
        return;
      }

      // A restored page keeps the pre-logout React/Apollo state, so it renders
      // as authenticated. fetchAuthSession reads the live token store, so if
      // there is no access token the user has logged out — drop the stale
      // snapshot with a fresh load that re-runs the guards and redirects to
      // login.
      const { tokens } = await fetchAuthSession();

      if (!tokens?.accessToken) {
        window.location.reload();
      }
    };

    window.addEventListener("pageshow", onPageShow);

    return () => {
      window.removeEventListener("pageshow", onPageShow);
    };
  }, []);

  return null;
};

export default BfCacheClearfix;
